import React from "react";

export function ErrorText({ className = "", children }) {
  return (
    <p className={`${className} mt-2 py-2 font-bold text-red-700`}>
      {children}
    </p>
  );
}
